import { type Registry as Services, service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';

export default class LookerDashboardAdapter extends ApplicationAdapter {
  @service declare destination: Services['destination'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // @ts-expect-error: Property 'buildURL' in type 'LookerDashboardAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot,
    requestType: string,
    query?: Record<string, unknown>,
  ) {
    // @ts-expect-error: Expected 3 arguments, but got 5.
    const url = super.buildURL(modelName, id, snapshot, requestType, query);

    if (this.hotelAndMarketService.market?.id) {
      return `${url}?market_id=${this.hotelAndMarketService.market.id}&user_type=custom_reporting`;
    }

    if (this.destination.destinationSubscription?.id) {
      return `${url}?user_type=daas`;
    }

    return url;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForCreateRecord() {
    return '/custom-reporting/dashboards';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForDeleteRecord(id: string) {
    return `/custom-reporting/dashboards/${id}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForDownload(
    id: string,
    exportFormat: string,
    params?: Record<string, string>,
  ) {
    const url = new URL(
      `/api/v3/custom-reporting/dashboards/${id}/download/${exportFormat}/`,
      this.host,
    );

    if (this.hotelAndMarketService.market?.id) {
      url.search = new URLSearchParams(
        Object.assign(params ?? {}, {
          market_id: this.hotelAndMarketService.market?.id,
          user_type: 'custom_reporting',
        }),
      ).toString();
    }

    if (this.destination.destinationSubscription?.id) {
      url.search = new URLSearchParams(
        Object.assign(params ?? {}, {
          user_type: 'daas',
        }),
      ).toString();
    }

    return url.toString();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForFindRecord(id: string) {
    return `/custom-reporting/dashboards/${id}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForThumbnail(id: string) {
    const url = new URL(
      `/api/v3/custom-reporting/dashboards/${id}/thumbnail/`,
      this.host,
    );

    if (this.hotelAndMarketService.market?.id) {
      url.search = new URLSearchParams({
        market_id: this.hotelAndMarketService.market.id,
        user_type: 'custom_reporting',
      }).toString();
    }

    if (this.destination.destinationSubscription?.id) {
      url.search = new URLSearchParams({
        user_type: 'daas',
      }).toString();
    }

    return url.toString();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForUpdateRecord(id: string) {
    return `/custom-reporting/dashboards/${id}`;
  }
}
